module.exports = __webpack_public_path__ + "img/sceneIcon2-4.af4d1275.png";